import { format, formatDistance } from 'date-fns'

export const formatDate = (date: string | number, useFormat: string) => {
  if (!date) return null
  return format(new Date(date), useFormat)
}

export const formatDiff = (date: string | number) => {
  if (!date) return null
  return formatDistance(new Date(date), new Date(), { addSuffix: true })
}
